import { atom } from 'recoil';
import { CallToAction, Variant } from '~/common/models';

export interface ModelColourPicker {
  contentId?: string;
  variants?: Variant[];
  modelName?: string;
  colourDisclaimer?: string;
  bookTestDriveCta?: CallToAction;
  hideBookTestDriveCta?: boolean;
  downloadBrochureCta?: CallToAction;
  hideDownloadBrochureCta?: boolean;
  buildYourOwnCta?: CallToAction;
  hideBuildYourOwnCta?: boolean;
  isVisible?: boolean;
}

export const ModelColorPickerState = atom<ModelColourPicker>({
  key: 'ModelColorPickerStateKey',
  default: {},
});
